import { render } from "./GeneralToolsButtons.vue?vue&type=template&id=86210c8a&scoped=true"
import script from "./GeneralToolsButtons.vue?vue&type=script&lang=js"
export * from "./GeneralToolsButtons.vue?vue&type=script&lang=js"

import "./GeneralToolsButtons.vue?vue&type=style&index=0&id=86210c8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86210c8a"]])

export default __exports__